import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { RoleService } from './../../core/services/role.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [DatePipe]
})
export class HomeComponent implements OnInit {

  myDate = new Date();
  dateText: any;

  constructor(
    private roleService: RoleService,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private datePipe: DatePipe
  ) { 
    this.dateText = this.datePipe.transform(this.myDate, 'dd.MM.yyyy');
  }

  ngOnInit(): void {
    if (!localStorage.getItem('foo')) { 
      localStorage.setItem('foo', 'no reload') 
      location.reload() 
    } else {
      localStorage.removeItem('foo') 
    }
    this.roleService.userHavePermission('');
  }


}
